<template>
  <zl-saas-container>
    <el-card>
      <div slot="header">
        <span class="saas-card-header-name">回复价格谈判</span>
      </div>
      <el-form label-position="left" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="询单名称、编号:">
              <span>{{ form.inquireCode }}</span>
            </el-form-item>
          </el-col>
          <!-- 新增谈判发起时间 -->
          <el-col :span="12">
            <el-form-item label="谈判发起时间:">
              {{
                form.negoStartTime &&
                  dayjs(form.negoStartTime).format('YYYY-MM-DD HH:mm:ss')
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="谈判截止时间:">
              {{
                form.negoEndTime &&
                  dayjs(form.negoEndTime).format('YYYY-MM-DD HH:mm:ss')
              }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="谈判总次数:">
              {{ form.negoTimes || '谈判次数没有轮次限制，可以无限制谈判' }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="采购人谈判说明:">
              <span>{{ form.negoExplain }}</span>
              <span class="look-detail" @click="lookDetail">查看详情</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="当前谈判轮次:">
              {{ form.negoCount }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-position="left" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="供应商答复:">
              <el-radio v-model="backStatus" :label="1" :disabled="isNego">接受谈判</el-radio>
              <el-radio v-model="backStatus" :label="2" :disabled="isNego">拒绝谈判</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="backStatus!==2">
            <el-form-item label="上传谈判报价文件:">
              <zs-upload :multiple="false" v-model="form.fileId" :isNeedAccetpText="true" :disabled="isNego" locationGuid="d1fbf9a1-01ac-4bc3-a4a2-2bd6d1cdd23a"></zs-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="">
              <el-input
                :disabled="isNego"
                type="textarea"
                :autosize="{ minRows: 4 }"
                v-model="remark"
                placeholder="可输入2000字"
                maxlength="2000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <zl-server-page-table
        :api="getApi"
        :border="false"
        showTotal
        ref="listTable"
        height="290px"
        v-if="loaded && backStatus!==2"
        smallPagination
        paginationLayout="total, sizes, prev, pager, next, jumper"
      >
        <el-table-column
          v-for="(row, index) in listColumns"
          :key="index"
          :label="row.columnNameCH"
          :prop="row.columnNameEN"
        >
          <span
            slot="header"
            :class="{
              isRequired:
                row.gysMust
            }"
          >
            {{ row.columnNameCH }}
          </span>
          <template slot-scope="scope">
            <span v-if="row.columnNameEN === 'amount'">{{scope.row[row.columnNameEN]}}</span>
            <span v-else-if="row.columnNameEN === 'name'">{{scope.row[row.columnNameEN]}}</span>
            <span v-else-if="row.columnNameEN === 'content'">{{scope.row[row.columnNameEN]}}</span>
            <span v-else-if="row.columnNameEN === 'neiRongJianJie'">{{scope.row[row.columnNameEN]}}</span>
            <template v-else>
              <el-input
                @blur="changeRow(scope.row, row.columnNameEN)"
                @keyup.native="rowChange(scope.row, row.columnNameEN)"
                v-validate="row.gysMust"
                :class="{
                  isNecessary:
                    (isValid && row.gysMust) &&
                    !scope.row[row.columnNameEN]
                }"
                :disabled="isNego"
                v-model.trim="scope.row[row.columnNameEN]"
              ></el-input>
            </template>
          </template>
        </el-table-column>
      </zl-server-page-table>
    </el-card>
    <template slot="footer">
      <el-button size="small" plain type="primary" @click="goback">
        返回
      </el-button>
      <el-button size="small" type="primary" @click="confirm" v-if="!isNego">提交</el-button>
    </template>
  </zl-saas-container>
</template>

<script>
import store from '@/store'
import dayjs from 'dayjs'
import { isEmpty, toNumber } from 'lodash-es'
import router from '@/router'
import zsUpload from '@/components/zsUpload'
export default {
  components: { zsUpload },
  data() {
    return {
      isEmpty,
      loaded: false,
      cacheId: '',
      supplierId: '',
      backStatus: 1,
      remark: '',
      dayjs,
      form: {},
      listColumns: [],
      quoteRule: 1,
      isValid: false,
      changedRow: {},
      isNego: false // 是否已回复谈判
    }
  },
  async created() {
    this.supplierId = this.$route.query.supplierId
    await store
      .dispatch('getGysNegoInfo', {
        id: this.supplierId
      })
      .then((res) => {
        this.form = res
      })
    store
      .dispatch('getXdColumnBySypplier', {
        inquireId: this.form.inquireId
      })
      .then((res) => {
        this.listColumns = JSON.parse(res.colValue || '[]')
        this.loaded = true
      })
    this.getGysInquireData()
  },
  methods: {
    /**
     * @description:采购数量 含税单价改变 计算合价
     */
    rowChange(row, columnNameEN) {
      if (columnNameEN === 'amount' || columnNameEN === 'taxUnitPrice' || columnNameEN === 'taxRate' || columnNameEN === 'noTaxUnitPrice') {
        if (isNaN(toNumber(row[columnNameEN]))) {
          row[columnNameEN] = isNaN(parseFloat(row[columnNameEN], 10)) ? '' : parseFloat(row[columnNameEN], 10)
          return
        }
      }
      if ((columnNameEN === 'amount' && row.taxUnitPrice || columnNameEN === 'taxUnitPrice' && row.amount) &&
            this.listColumns.findIndex(i => i.columnNameEN === 'taxCombPrice') !== -1
      ) {
        this.$set(row, 'taxCombPrice', this.$zl.util.multiply(row.taxUnitPrice, row.amount))
      }
      if ((columnNameEN === 'amount' && row.noTaxUnitPrice || columnNameEN === 'noTaxUnitPrice' && row.amount) &&
            this.listColumns.findIndex(i => i.columnNameEN === 'noTaxCombPrice') !== -1
      ) {
        this.$set(row, 'noTaxCombPrice', this.$zl.util.multiply(row.noTaxUnitPrice, row.amount))
      }
    },
    changeRow(row, columnNameEN) {
      if (columnNameEN === 'amount' || columnNameEN === 'taxUnitPrice' || columnNameEN === 'taxRate' || columnNameEN === 'noTaxUnitPrice') {
        if (isNaN(toNumber(row[columnNameEN]))) {
          row[columnNameEN] = isNaN(parseFloat(row[columnNameEN], 10)) ? '' : parseFloat(row[columnNameEN], 10)
        } else if (row[columnNameEN][row[columnNameEN].length - 1] === '.') {
          row[columnNameEN] = parseInt(row[columnNameEN], 10)
        }
      }
      this.changedRow[row.id] = row
    },
    async getApi(args) {
      if (!this.cacheId) {
        await store.dispatch('getListIdGys').then((res) => {
          this.cacheId = res
        })
      }
      let params = {
        pageNum: args.page,
        pageSize: args.size,
        unionId: this.supplierId,
        id: this.cacheId,
        loadFromDB: true
      }
      let apiName = ''
      // 进行了多次报价，获取最新的谈判报价数据
      if (this.form.receiveCount > 0) {
        apiName = 'pageTpZSGysInventory'
      } else {
        apiName = 'pageZSBjGysInventory'
      }
      return store
        .dispatch(apiName, params)
        .then((res) => {
          res.list.map(val => {
            let rowVal = JSON.parse(val.rowValue)
            this.changedRow[val.id] = rowVal
          })
          return {
            rows: res.list
              .map((t) => ({
                ...((t.rowValue && JSON.parse(t.rowValue)) || {}),
                id: t.id
              })),
            // .map((t) => this.changedRow[t.id] || t),
            total: res.totalCount
          }
        })
    },
    listCurrency() {
      return store.dispatch('listCurrencyGys')
    },
    async confirm() {
      if (this.backStatus === 2) { // 拒绝谈判的时候
        if (!this.remark) {
          this.$message.warning('请填写拒绝理由！')
          return false
        }
      }
      // 必填校验
      const requiredList = this.listColumns.filter(i => i.gysMust)
      for (const key in this.changedRow) {
        for (const p of requiredList) {
          if (this.changedRow[key][p.columnNameEN] === '' || this.changedRow[key][p.columnNameEN] === null || this.changedRow[key][p.columnNameEN] === undefined) {
            this.isValid = true
            this.$zl.message.warn(`${p.columnNameCH}必填！`)
            return
          }
        }
      }
      const list = Object.keys(this.changedRow).map((key) => ({
        text: this.changedRow[key] && this.changedRow[key].id && JSON.stringify(this.changedRow[key])
      }))

      if (list.filter(val => val.text).length > 0) {
        await store.dispatch('updateListBySupplier', {
          id: this.cacheId,
          list: list.filter(val => val.text)
        })
      }
      await store
        .dispatch('summitGysNegoBack', {
          baoJiaFileGroupGuid: this.form.fileId,
          supplierId: this.supplierId,
          backStatus: this.backStatus,
          remark: this.remark,
          cacheId: this.cacheId
        })
        .then((res) => {
          this.$zl.message.success('提交成功')
          this.$router.push({
            path: '/supplier/purchaseManage/summaryWorkbench',
            query: {
              id: this.form.inquireId
            }
          })
        })
    },
    // 查看询单详情
    lookDetail() {
      this.$router.push({
        name: 'SupplierManageInquiryBaojiaDetail',
        query: {
          id: this.supplierId,
          type: 'tanpan'
        }
      })
    },
    goback() {
      this.$router.push({
        path: '/supplier/purchaseManage/summaryWorkbench',
        query: {
          id: this.form.inquireId
        }
      })
    },
    async getGysInquireData() {
      await store
        .dispatch('pageInquireSupplier', { inquireId: this.form.inquireId, createTimeStart: null, createTimeEnd: null, inquireType: '', status: null, quoteTimeStart: null, quoteTimeEnd: null, pageNum: 1, pageSize: 15 }).then(async(res) => {
          let currentInquire = {}
          if (res.list && res.list.length > 0) {
            currentInquire = res.list[0]
          }
          const nowTime = dayjs().valueOf()
          this.isNego = !(currentInquire.backStatus === 0 &&
                        currentInquire.finishTime < nowTime &&
                        currentInquire.negoEndTime > nowTime &&
                        currentInquire.nego &&
                        currentInquire.supplierHandle &&
                        currentInquire.status === 3)
        })
    }
  }
}
</script>

<style lang="scss">
.quoted-price-dialog {
  .el-dialog__body {
    padding: 10px 20px 5px 20px;
  }
}
.look-detail{
  color: #4655FF;
  cursor: pointer;
  margin-left: 20px;
  font-size: 14px;
}
</style>
